import React from 'react';
import { triggerEdapButtonClick, eventCategories } from '../../util/edap';

const QualificationSection = () => {
    return (
        <>
            <div className="cpp-page__content__qualification">
                <h2 className="section-heading">How to qualify</h2>
                <p>
                    Connectivity partners can secure Elite or Preferred status
                    for 2028 by reaching specific goals and business and
                    technical metrics under the categories listed.
                    <sup>3</sup>
                </p>
                <div className="cpp-page__content__qualification-details">
                    <div className="section-heading">Qualifying metrics</div>
                    <table className="table table-responsive">
                        <tbody>
                            <tr>
                                <th>
                                    <strong>Category</strong>
                                </th>
                                <th>
                                    <strong>Metric</strong>
                                </th>
                            </tr>
                            <tr>
                                <td>Commercial performance</td>
                                <td>
                                    <p>
                                        Measures Net Booking Value (NBV):
                                        total booked reservation amount
                                        including taxes and fees, net of
                                        cancellations.
                                    </p>
                                    <p>
                                        Tracks year-over-year growth in NBV for connected properties.
                                    </p>
                                    <p>
                                        Net new properties year-over-year growth.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>Technical</td>
                                <td>
                                    <p>
                                        Focuses on adoption of key capabilities such
                                        as reservation management (delivery, retrieval,
                                        update), product management and Autonomous
                                        Distribution.
                                    </p>
                                    <p>
                                        Measures performance across all adopted capabilities.
                                    </p>
                                    <p>
                                        Measures the percentage of properties that have
                                        at least one API call in a given period.
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>Partnership quality</td>
                                <td>
                                    <p>
                                        A minimum of one Optimization Initiative is
                                        mandatory to qualify for Elite or Preferred
                                        status. A focus on driving measurable results.
                                    </p>
                                    <p>
                                        Assesses overall collaboration with Expedia Group.
                                        Includes participation surveys, leadership and
                                        technical engagement, innovation, and commitment
                                        to Autonomous Supply suite.
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>Please consult your account manager for more details.</p>
                    <div className="cpp-minimum-requirements-wrapper">
                        <div className="section-heading">
                            2027/28 Connectivity Partner Program minimum
                            requirements
                        </div>
                        <p>
                            System type requirements: Property Distribution
                            Software
                            <sup>4</sup>
                        </p>
                        <p>
                            Commercial requirements: Expedia Group API License
                            Agreement acceptance.
                        </p>
                        <p>
                            Technical requirements: Availability/Rates API with
                            support for Expedia Traveler Preference (ETP);
                            Booking APIs with support for virtual cards, Value
                            Add Promotions (VAP), and extended POS; PCI compliance
                            (where applicable).
                        </p>
                        <p>
                            As part of the Expedia Group Connectivity Partner
                            Agreement, you are required to maintain the health
                            of your connection and may be required to implement
                            mandatory updates and modifications. Expedia Group
                            reserves the right, in its sole discretion, to
                            determine whether a connectivity partner is
                            eligible to participate in, or remain in, the
                            program.
                        </p>
                    </div>
                    <div className="cpp-timeline-wrapper">
                        <div className="section-heading">Timeline</div>
                        <p>
                            The Connectivity Partner Program will operate on an
                            annual basis:
                        </p>
                        <ul className="timeline-list">
                            <li>October 2026: 2027/28 program criteria announced</li>
                            <li>
                                January 1 - December 31, 2027: Program
                                qualification measurement period for 2028
                            </li>
                            <li>
                                September 30, 2027: Deadline to submit
                                capability adoption certification requests
                            </li>
                            <li>
                                October 22, 2027: Deadline to submit
                                Optimization Initiatives (OI) planning requests
                            </li>
                            <li>
                                November 24, 2027: Deadline to complete
                                capability adoption certifications
                            </li>
                            <li>
                                December 10, 2027: Deadline to complete
                                Optimization Initiative (OI) for credit
                            </li>

                            <li>
                                Q1 2028 - Elite and Preferred partners announced
                                for 2028 program
                            </li>
                        </ul>
                    </div>
                    <p className="current-cpp-list">
                        <a
                            onClick={triggerEdapButtonClick(
                                eventCategories.CONTENT_LINKS,
                                'Current Connectivity Partner list'
                            )}
                            href="https://www.expediapartnercentral.com/connectivity"
                        >
                            See the current list of Elite and Preferred
                            Connectivity Partners
                        </a>
                    </p>
                </div>
            </div>
        </>
    );
};

export default QualificationSection;
